import React from 'react';
import ReceiptResolutionWorkspace from './ReceiptResolutionWorkspace';

/** 수납결의등록 */
export default function ReceiptResolutionRegister() {
  return <ReceiptResolutionWorkspace screenMode="register" />;
}
